import React from 'react';
import { ExternalLink, Newspaper } from 'lucide-react';
interface Article {
  title: string;
  publication: string;
  url: string;
}
const articles: Article[] = [{
  publication: 'TechBullion',
  title: 'Architecting Trust at Scale: How Arthur Miller is Reimagining Financial Infrastructure',
  url: 'https://techbullion.com/architecting-trust-at-scale-how-arthur-miller-is-reimagining-financial-infrastructure/'
}, {
  publication: 'Stars of Entrepreneurship',
  title: 'Arthur Miller Brings FiQIS to Market with Transparency and Stakeholder Engagement',
  url: 'https://starsofentrepreneurship.com/arthur-miller-brings-fiqis-to-market-with-transparency-and-stakeholder-engagement/'
}, {
  publication: 'SD Weekly',
  title: "Arthur Miller's FiQIS Tackles the Hidden Costs of Legacy Banking Infrastructure",
  url: 'https://sdweekly.com/arthur-millers-fiqis-tackles-the-hidden-costs-of-legacy-banking-infrastructure/'
}, {
  publication: 'Belmont Star',
  title: "Arthur Miller's FiQIS Integrates Post-Quantum Encryption Before Launch",
  url: 'https://belmontstar.com/arthur-millers-fiqis-integrates-post-quantum-encryption-before-launch/'
}, {
  publication: 'Markets Herald',
  title: 'Arthur Miller Designed FiQIS as Modular Infrastructure for Diverse Banking Needs',
  url: 'https://marketsherald.com/arthur-miller-designed-fiqis-as-modular-infrastructure-for-diverse-banking-needs/'
}, {
  publication: 'Ritz Herald',
  title: "Servant Leadership in High-Tech Environments: Arthur Miller's Blueprint",
  url: 'https://ritzherald.com/servant-leadership-in-high-tech-environments-arthur-millers-blueprint/'
}, {
  publication: 'Yahoo Finance',
  title: 'Beyond BNPL: Building Smarter Credit Systems',
  url: 'https://finance.yahoo.com/news/beyond-bnpl-building-smarter-credit-222500750.html'
}, {
  publication: 'USA Wire',
  title: 'Arthur Miller on Ethical Innovation: Balancing AI, Security, and Human Impact',
  url: 'https://usawire.com/arthur-miller-on-ethical-innovation-balancing-ai-security-and-human-impact/'
}, {
  publication: 'CEO Weekly',
  title: 'Arthur Miller on Building Financial Systems People Can Trust',
  url: 'https://ceoweekly.com/arthur-miller-on-building-financial-systems-people-can-trust/'
}, {
  publication: 'NY Weekly',
  title: 'The Post-Quantum Banking Era: Preparing Financial Systems for What Comes Next',
  url: 'https://nyweekly.com/business/the-post-quantum-banking-era-preparing-financial-systems-for-what-comes-next/'
}, {
  publication: 'Business Insider',
  title: 'Beyond BNPL: Building Smarter Credit Systems for the Next Decade',
  url: 'https://markets.businessinsider.com/news/stocks/beyond-bnpl-building-smarter-credit-systems-for-the-next-decade-with-arthur-miller-1035208141'
}, {
  publication: 'AP News',
  title: 'Building Smarter Credit Systems for the Next Decade with Arthur Miller',
  url: 'https://apnews.com/press-release/access-newswire/beyond-bnpl-building-smarter-credit-systems-for-the-next-decade-with-arthur-miller-476db6f3d8abb0254fda05dc11b0f24e'
}];
export function ArticlesGrid() {
  return <section id="articles" className="py-24 bg-[#0B1120] px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-22" data-mp="3k66v32old4sp">
      {/* Decorative background elements */}
      <div className="absolute top-10 right-10 text-cyan-500/10 opacity-30" data-id="element-23" data-mp="gm2guyxnzobn">
        <Newspaper className="h-32 w-32" data-id="element-24" data-mp="bo0y6f45hr0p" />
      </div>
      <div className="absolute bottom-10 left-10 text-cyan-500/10 opacity-30" data-id="element-25" data-mp="bqdopgnz59pd">
        <Newspaper className="h-24 w-24" data-id="element-26" data-mp="6vzqz7luaqhj" />
      </div>

      <div className="max-w-7xl mx-auto relative" data-id="element-27" data-mp="1z0wup26ejjc">
        <div className="text-center mb-16" data-id="element-28" data-mp="1y7o5ijnpjyk">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-cyan-500/20 rounded-2xl mb-4 backdrop-blur-sm border border-cyan-500/30 glow-cyan" data-id="element-29" data-mp="zeeskca7k1yg">
            <Newspaper className="h-8 w-8 text-cyan-400" data-id="element-30" data-mp="ul25w7p3a58c" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-31" data-mp="f3kcfs4ritpf">
            Featured In
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full mb-6" data-id="element-32" data-mp="k5jixavsu6ql"></div>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-33" data-mp="59294o39d065">
            Insights, interviews, and thought leadership across major financial
            and technology publications.
          </p>
        </div>

        {/* Stats bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 max-w-4xl mx-auto" data-id="element-34" data-mp="12uzinvzntv5y">
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 text-center border border-white/10 shadow-sm" data-id="element-35" data-mp="o6d4vypolbgu">
            <div className="text-3xl font-bold text-cyan-400 mb-1" data-id="element-36" data-mp="t44yqy9vz7no">
              {articles.length}+
            </div>
            <div className="text-sm text-slate-500" data-id="element-37" data-mp="1gtpivkhs0ayj">Publications</div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 text-center border border-white/10 shadow-sm" data-id="element-38" data-mp="1lm93v2ism8dd">
            <div className="text-3xl font-bold text-emerald-400 mb-1" data-id="element-39" data-mp="36a1s4hz470l7">10+</div>
            <div className="text-sm text-slate-500" data-id="element-40" data-mp="31bi66hkitosu">Major Outlets</div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 text-center border border-white/10 shadow-sm" data-id="element-41" data-mp="3g1xui588hcv8">
            <div className="text-3xl font-bold text-purple-400 mb-1" data-id="element-42" data-mp="3b3e5fvycfkyn">2026</div>
            <div className="text-sm text-slate-500" data-id="element-43" data-mp="2nc8plgseksoc">Recent Year</div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 text-center border border-white/10 shadow-sm" data-id="element-44" data-mp="2idxel2qdgc4j">
            <div className="text-3xl font-bold text-orange-400 mb-1" data-id="element-45" data-mp="2wdp0rqr1kytm">100%</div>
            <div className="text-sm text-slate-500" data-id="element-46" data-mp="2sc3g3j89ng8v">Thought Leader</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-47" data-mp="bmxy08o84w1s">
          {articles.map((article, index) => <a key={index} href={article.url} target="_blank" rel="noopener noreferrer" className="group block bg-white/5 backdrop-blur-sm rounded-xl p-6 shadow-sm hover:shadow-lg border border-white/10 hover:border-cyan-500/30 hover:bg-white/10 transition-all duration-300 flex flex-col h-full hover:-translate-y-1" data-id="element-48" data-mp="7kku7pt1f87n" data-mpi={index}>
              <div className="flex items-center justify-between mb-4" data-id="element-49" data-mp="3eeuj9ciy9bnx">
                <span className="text-sm font-bold text-cyan-400 uppercase tracking-wider group-hover:text-cyan-300 transition-colors" data-id="element-50" data-mp="2hpv8nquw7xsk">
                  {article.publication}
                </span>
                <div className="w-8 h-8 rounded-full bg-cyan-500/10 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors" data-id="element-51" data-mp="2qqjlwjcgpu4e">
                  <ExternalLink className="h-4 w-4 text-cyan-400 group-hover:scale-110 transition-transform" data-id="element-52" data-mp="2viktvt2lkyom" />
                </div>
              </div>
              <h3 className="text-lg font-semibold text-white group-hover:text-cyan-300 transition-colors leading-snug flex-grow" data-id="element-53" data-mp="230gv06kaau7d">
                {article.title}
              </h3>
              <div className="mt-4 pt-4 border-t border-white/10" data-id="element-54" data-mp="1qi3f5ug8nbvo">
                <span className="text-sm text-slate-500 group-hover:text-cyan-400 transition-colors font-medium" data-id="element-55" data-mp="1qiwdq851mv2q">
                  Read article →
                </span>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}